import styled from "styled-components";
import { Link } from "react-router-dom";
import { MenuOutlined } from "@ant-design/icons";

export const HeaderSection = styled("header")`
  padding: 1rem 0.5rem;

  .ant-row-space-between {
    align-items: center;
    text-align: center;
  }
`;

export const LogoContainer = styled(Link)`
  display: flex;
  margin-top: 10px;
`;

export const NavLink = styled("div")`
  display: inline-block;
  text-align: center;
`;

export const CustomNavLink = styled("div")`
  width: 203px;
  display: inline-block;

  @media only screen and (max-width: 411px) {
    width: 150px;
  }

  @media only screen and (max-width: 320px) {
    width: 118px;
  }
`;

export const Burger = styled("div")`
  @media only screen and (max-width: 890px) {
    display: block;
  }

  display: none;

  svg {
    fill: #2e186a;
  }
`;

export const NotHidden = styled("div")`
  @media only screen and (max-width: 890px) {
    display: none;
  }
`;

export const Menu = styled("h5")`
  font-size: 1.5rem;
  font-weight: 600;
  text-align: center;
`;

export const CustomNavLinkSmall = styled(NavLink)`
  font-size: 1.2rem;
  color: #18216d;
  transition: color 0.2s ease-in;
  margin: 0.5rem 1rem;

  @media only screen and (max-width: 768px) {
    margin: 1.25rem 2rem;
  }
`;

export const Label = styled("span")`
  font-weight: 500;
  color: #404041;
  text-align: right;
  display: flex;
  justify-content: space-between;
  align-items: baseline;
`;

export const Outline = styled(MenuOutlined)`
  font-size: 22px;
`;

export const Span = styled("span")`
  cursor: pointer;
  transition: all 0.3s ease-in-out;

  &:hover,
  &:active,
  &:focus {
    color: rgb(255, 130, 92);
    text-underline-position: under;
    text-decoration: rgb(255, 130, 92) wavy underline;
  }
`;

export const ToggleWrapper = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  top: 20px;
  right: 20px; /* Adjust as per design */
  z-index: 1000;
  @media (max-width: 768px) {
    top: 40px; /* move closer to top on mobile */
    right: 80px; /* move closer to right edge on mobile */
  }
`;

export const ToggleLabel = styled.span`
  margin-right: 10px;
  font-weight: bold;
  color: #000;
`;

export const ToggleButton = styled.button<{ active: boolean }>`
  width: 80px;
  height: 36px;
  border-radius: 18px;
  border: none;
  background-color: rgb(179, 177, 177);
  position: relative;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
  font-size: 14px;
  font-weight: 500;

  transition: background-color 0.3s;
  overflow: hidden;

  span {
    z-index: 2;
    width: 50%;
    text-align: center;
    transition: color 0.3s;
    color: #fff;
  }

  .active {
    font-weight: bold;
    color: #000;
  }

  .circle {
    position: absolute;
    top: 3px;
    left: ${({ active }) => (active ? "42px" : "3px")};
    width: 34px;
    height: 30px;
    background: #2e186a;
    border-radius: 18px;
    transition: left 0.3s;
    z-index: 1;
  }
`;
